<div class="row justify-content-center">

  <div class="col-lg-8 content-area">
    <div class="page-card">
      <div id="settings">
        <h2 class="f-s-20 f-w-700 m-t-24"
            [class.active-heading]="selectedSection === 'settings'">
          Settings
        </h2>
        <p class="f-s-14">
          You can manage your profile information, email configuration, User roles through settings.
        </p>
      </div>

      <div id="my-account">
        <h2 class="f-s-20 f-w-700 m-t-24"
            [class.active-heading]="selectedSection === 'my-account'">
          My Account
        </h2>

        <p class="f-s-14">
          In this you can view all the details of your profile, licensing details and also you get an option to upgrade your plan in the upper right side.
        </p>

        <img src="../../../../assets/images/logos/myaccount.jpg" />

        <p class="f-s-14">
          <strong>Licensing Details:</strong>
        </p>

        <ul class="f-s-14">
          <li>Subscription Type</li>
          <li>Submission Status</li>
          <li>Subscription Start Date</li>
          <li>Subscription End Date</li>
          <li>User Count</li>
          <li>Charity Count</li>
          <li>User Status</li>
          <li>Charity Status</li>
        </ul>
      </div>

      <div id="email-configuration">
        <h2 class="f-s-20 f-w-700 m-t-24"
            [class.active-heading]="selectedSection === 'email-configuration'">
          Email Configuration
        </h2>

        <p class="f-s-14">
          This allows you to set up and manage email settings.
        </p>

        <img src="../../../../assets/images/logos/emailconfiguration.jpg" />

        <p class="f-s-14">
          <strong>Sender Details</strong>
        </p>

        <ul class="f-s-14">
          <li>
            <strong>Sender Email*</strong> - Email address from which you want to send the email.
          </li>
          <li>
            <strong>Reply To</strong> - This allows you to specify an alternative email address where replies to the sent emails will be directed instead of the sender's email address.
          </li>
        </ul>

        <p class="f-s-14">
          <strong>Authentication Details</strong>
        </p>

        <ul class="f-s-14">
          <li>
            <strong>SMTP Server Address*</strong> - The Simple Mail Transfer Protocol (SMTP) is an internet standard communication protocol for electronic mail transmission. Enter the name of your SMTP Server.
          </li>
          <li>
            <strong>Port Number*</strong> - A port number is a way to identify a specific process to which an internet or other network message is to be forwarded when it arrives at a server.
          </li>
          <li>
            <strong>Encryption Type*</strong> - Select the encryption type from the dropdown.
          </li>
        </ul>

        <p class="f-s-14">
          <strong>Email Server Details</strong>
        </p>

        <ul class="f-s-14">
          <li>
            <strong>User Name*</strong> - Enter the user name of the admin.
          </li>
          <li>
            <strong>Password*</strong> - Enter the password of the admin.
          </li>
        </ul>

        <p class="f-s-14">
          After you enter all the details, click on ‘Save’.
        </p>
      </div>

      <div id="presenter-information">
        <h2 class="f-s-20 f-w-700 m-t-24"
            [class.active-heading]="selectedSection === 'presenter-information'">
          Preference
        </h2>

        <p class="f-s-14">
          You can customise application behaviour and general settings
        </p>

        <h2 class="f-s-20 f-w-700 m-t-24">Presenter Information</h2>

        <p class="f-s-14">
          You can click on ‘Change Setting’,
        </p>

        <img src="../../../../assets/images/logos/presenterinformation.png" />

        <p class="f-s-14">
          You can add <strong>‘Agent Details’</strong> under <strong>‘Tax Adviser Details’</strong>.
        </p>

        <img src="../../../../assets/images/logos/agentdetails.png" />

        <h4 class="sub-section-title">Agent Details</h4>

        <ul class="help-sub-list">
          <li><strong>Agent Name*</strong> - You can enter the name.</li>
          <li><strong>Company Name</strong> - Enter the company name.</li>
          <li><strong>Email Address*</strong> - Enter the email address.</li>
          <li><strong>Telephone Number*</strong> - Enter the phone number.</li>
          <li><strong>Address</strong> - Enter the address.</li>
          <li><strong>Country</strong> - Enter the country.</li>
          <li><strong>Postcode</strong> - Enter the postcode.</li>
        </ul>

        <h4 class="sub-section-title">Gateway Authentication Details</h4>

        <ul class="help-sub-list">
          <li><strong>Presenter ID*</strong> - This is a mandatory field.</li>

          <li>
            <strong>Presenter Authentication Code*</strong> - This is the mandatory field &amp; also have an option to hide the code
            <img class="eyeiconclass" src="../../../../assets/images/logos/eyeicon.jpg" /><strong>Re-enter Authentication Code*</strong> - Re-enter the code for confirmation.
          </li>
        </ul>

        <p class="f-s-14">
          After entering all the details, you can click on ‘Save’.
        </p>

      </div>

      <div id="email-template">
        <h2 class="f-s-20 f-w-700 m-t-24"
            [class.active-heading]="selectedSection === 'email-template'">
          Email Template
        </h2>

        <p class="f-s-14">
          You can click on ‘Change Setting’
        </p>

        <img src="../../../../assets/images/logos/emailtemplate.png" />

        <p class="f-s-14">
          You will have a layout for various sections, click on ‘Edit’ and add the details and click on ‘Update’.
        </p>

        <img src="../../../../assets/images/logos/emailtemplatebig.png" />

        <p class="f-s-14">
          <strong>You can edit templates for:</strong>
        </p>

        <ul class="f-s-14">
          <li>Trial Balance</li>
          <li>Statement of Financial Assets</li>
          <li>Balance Sheet</li>
          <li>Receipts &amp; Payments</li>
          <li>Statement of Assets &amp; Liabilities</li>
          <li>Accounts</li>
        </ul>
      </div>

      <div id="session-timeout">
        <h2 class="f-s-20 f-w-700 m-t-24"
            [class.active-heading]="selectedSection === 'session-timeout'">
          Session Timeout
        </h2>

        <p class="f-s-14">
          You can configure the <strong>automatic logout period</strong> for inactive user sessions.
        </p>

        <p class="f-s-14">
          Click on <strong>‘Change Setting’</strong> to update the required logout duration.
        </p>

        <img class="session" src="../../../../assets/images/logos/sessiontimeout.png" />

        <p class="f-s-14">
          You can enter the duration of inactivity after which the user will be logged out automatically.
        </p>

        <img class="session" src="../../../../assets/images/logos/sessiontimeoutduration.png" />

        <p class="f-s-14">
          And click on ‘Update’.
        </p>
      </div>

      <div id="user-management">
        <h2 class="f-s-20 f-w-700 m-t-24"
            [class.active-heading]="selectedSection === 'user-management'">
          User Management
        </h2>

        <p class="f-s-14">
          The <strong>User Management</strong> section allows you to manage <strong>user access</strong> within the system. You can <strong>create and assign roles</strong>, <strong>add users</strong>, and <strong>configure access permissions</strong> based on the requirements of each user.
        </p>
        <img src="../../../../assets/images/logos/usermanagement.jpg" />
      </div>

      <div id="search-user">
        <h2 class="f-s-20 f-w-700 m-t-24"
            [class.active-heading]="selectedSection === 'search-user'">
          Search
        </h2>

        <p class="f-s-14">
          You can search for specific <strong>roles</strong> or <strong>users</strong> by entering the relevant details in the search field available under the <strong>‘Roles’</strong> and <strong>‘Users’</strong> sections.
        </p>
        <img class="serches" src="../../../../assets/images/logos/search.png" />
      </div>

      <div id="add-roles">
        <h2 class="f-s-20 f-w-700 m-t-24"
            [class.active-heading]="selectedSection === 'add-roles'">
          Add Roles
        </h2>

        <p class="f-s-14">
          You can create a new role by clicking on <strong>‘Add Roles’</strong> and defining the required role details and permissions.
        </p>

        <img class="addusersbtn" src="../../../../assets/images/logos/addrolesbutton.png" />

        <p class="f-s-14">
          You have to enter below mentioned details:
        </p>

        <ul class="help-sub-list">
          <li><strong>Role Name*</strong> - Enter the specific role name.</li>
          <li><strong>Description</strong> - You can add description in detail.</li>
          <li><strong>Administrative Access</strong> - You can enable this option, so that the role will have all the available access. Also you can select the specific access.</li>
        </ul>
        <div class="d-flex align-items-center gap-2">
         <p class="f-s-14 m-0">You can select different access from different modules, </p>
        </div>
        <div class="d-flex align-items-center flex-wrap">
          <span class="sub-section-title">Charities</span>
          
          <span style="margin-left: 30px; margin-top: 10px; ">
            - You have an option to enable all access  <img style="height:32px" src="../../../../assets/images/logos/enableall.png" />
          </span>
        </div>
        <ul class="help-sub-list">
          <li><strong>View</strong> - This allows user to view data without making any changes.</li>
          <li><strong>Edit</strong> - This allows user to update or modify existing records.</li>
          <li><strong>Create</strong> - This allows user to create new records.</li>
          <li><strong>Delete</strong> - This allows user to remove existing record.</li>
          <li><strong>Import Trial Balance</strong> - This allows user to import charity from Companies House.</li>
          <li><strong>Export/Print</strong> - This allows user to export or download data or reports.</li>
          <li><strong>Send Mail</strong> - This allows user to send mail.</li>
          <li><strong>Submit</strong> - This allows user to file statutory forms & make official submissions.</li>
        </ul>

        <h4 class="sub-section-title">Submission History</h4>

        <ul class="help-sub-list">
          <li><strong>View</strong> - This allows user to view data without making any changes.</li>
          <li><strong>Export/Print</strong> - This allows user to export or download data or reports.</li>
        </ul>

        <h4 class="sub-section-title">Reports</h4>

        <ul class="help-sub-list">
          <li><strong>Generate Report</strong> - This allows user to create & manage Company Officer’s report.</li>
          <li><strong>Export/Print</strong> - This allows user to export or download data or reports.</li>
        </ul>

        <h4 class="sub-section-title">Settings</h4>

        <ul class="help-sub-list">
          <li><strong>View</strong> - This allows user to view data without making any changes.</li>
          <li><strong>Edit</strong> - This allows user to update or modify existing records.</li>
          <li><strong>Create</strong> - This allows user to create new records.</li>
          <li><strong>Delete</strong> - This allows user to remove existing record.</li>
        </ul>

        <p class="f-s-14">
          And click on <strong>'Save'</strong>.
        </p>

      </div>

      <div id="add-user">
        <h2 class="f-s-20 f-w-700 m-t-24"
            [class.active-heading]="selectedSection === 'add-user'">
          Add User
        </h2>
        <p class="f-s-14">
          You can add a new user by clicking on <strong>‘+Add Users’</strong> and entering the required user details.
        </p>
        <img class="addusersbtn" src="../../../../assets/images/logos/addusersbutton.png" />
        <p class="f-s-14">
          Then enter the following details,
        </p>

        <img src="../../../../assets/images/logos/addusers.jpg" />

        <p class="f-s-14">
          <strong>Profile Photo-</strong> You can add profile photo.
        </p>

        <p class="f-s-14">
          <strong>Title*- </strong>You can choose from the dropdown.
        </p>

        <p class="f-s-14">
          <strong>Username*- </strong> You have to enter First Name &amp; Last Name.
        </p>

        <p class="f-s-14">
          <strong>Email Address*- </strong> Enter email address.
        </p>

        <p class="f-s-14">
          <strong>Contact Number*- </strong> Enter Contact Number
        </p>

        <p class="f-s-14">
          You can also add address details by selecting the option, and fill the Address, Town/City, Country, Postcode details
        </p>

        <img src="../../../../assets/images/logos/addaddressdetails.png" />

        <p class="f-s-14">
          And mention all the details,
        </p>

        <img src="../../../../assets/images/logos/addressdetailspage.jpg" />

        <p class="f-s-14">
          And click on ‘Next’,
        </p>

        <p class="f-s-14">
          Then in ‘Set Permissions’,
        </p>

        <p class="f-s-14">
          Select the role you want to give the added user.
        </p>

        <p class="f-s-14">
          And click on ‘Save’.
        </p>

        <p class="f-s-14">
          The new user will be created and you can view it in the preview.
        </p>
      </div>
    </div>
    </div>

  <div class="col-lg-3">

    <div class="on-page-sidebar">

      <p class="sidebar-title">On this page</p>

      <ul class="scroll-container submenu-level-2">

        <li [class.active]="selectedSection === 'settings'"
            (click)="changeSection('settings')">
          <a>Settings</a>
        </li>

        <li [class.parent-active]="selectedSection === 'my-account'">

          <a (click)="changeSection('my-account')">
            My Account
          </a>

        </li>

        <li [class.parent-active]="selectedSection === 'email-configuration'">

          <a (click)="changeSection('email-configuration')">
            Email Configuration
          </a>

        </li>

        <!-- Preference -->

        <li [class.parent-active]="[
              'presenter-information',
              'email-template',
              'session-timeout'
            ].includes(selectedSection)">

          <div class="menu-header"
               (click)="preferenceExpanded = !preferenceExpanded">

            <span>Preference</span>
            <span>{{ preferenceExpanded ? '−' : '+' }}</span>

          </div>

          <ul
              class="submenu-level-2">

            <li [class.active]="selectedSection === 'presenter-information'"
                (click)="changeSection('presenter-information')">

              Presenter Information

            </li>

            <li [class.active]="selectedSection === 'email-template'"
                (click)="changeSection('email-template')">

              Email Template

            </li>

            <li [class.active]="selectedSection === 'session-timeout'"
                (click)="changeSection('session-timeout')">

              Session Timeout

            </li>

          </ul>

        </li>

        <!-- User Management -->

        <li class="user-group" [class.parent-active]="[
              'search-user',
              'add-roles',
              'add-user'
            ].includes(selectedSection)">

          <div class="menu-header"
               (click)="userManagementExpanded = !userManagementExpanded">

            <p>User Management</p>
            <span>{{ userManagementExpanded ? '−' : '+' }}</span>

          </div>

          <ul 
              class="submenu-level-2">

            <li [class.active]="selectedSection === 'search-user'"
                (click)="changeSection('search-user')">

              Search

            </li>

            <li [class.active]="selectedSection === 'add-roles'"
                (click)="changeSection('add-roles')">

              Add Roles

            </li>

            <li [class.active]="selectedSection === 'add-user'"
                (click)="changeSection('add-user')">

              Add User

            </li>

          </ul>

        </li>

      </ul>

    </div>

  </div>

  </div>

    
